import { render } from "./tracking.vue?vue&type=template&id=2f8359b7&scoped=true"
import script from "./tracking.vue?vue&type=script&lang=js"
export * from "./tracking.vue?vue&type=script&lang=js"

import "./tracking.vue?vue&type=style&index=0&id=2f8359b7&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8359b7"]])

export default __exports__